export enum CATEGORYTYPE {
  DOVIZ = 'DOVIZ',
  ZIYNET = 'ZIYNET',
  PARITE = 'PARITE',
  KUYUMCU = 'KUYUMCU',
  GRAMALTIN = 'GRAM ALTIN',
  PERAKENDE = 'PERAKENDE',
}
